module.exports = __webpack_public_path__ + "img/12925.749a3f7f.jpg";